import Phaser from 'phaser';

/** Phaser doesn't propagate Container depth to children for input
 *  hit-testing. Walk the tree and force every descendant to the given
 *  depth, so a modal's interactive children sit above the underlying
 *  app windows in the input sort. */
export const propagateDepth = (target: Phaser.GameObjects.GameObject, depth: number): void => {
  const t = target as Phaser.GameObjects.GameObject & {
    setDepth?: (d: number) => unknown;
    list?: Phaser.GameObjects.GameObject[];
  };
  t.setDepth?.(depth);
  // Walk children if this looks like a Container (fully real Phaser
  // Container has `iterate`/`list`; the test mocks supply neither).
  if (Array.isArray(t.list)) {
    for (const child of t.list) propagateDepth(child, depth);
  }
};
